import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import ProductApprovalController from './productApproval.controller';
import { Layout, PageHeader, EmptyState } from '../common';
import { Button, Pagination, Checkbox, Skeleton } from 'antd';
import { PackageCheck, CircleCheck, RotateCw, CircleX } from 'lucide-react';
import { AuditReviewCard } from '../audit-console/elements';

class ShelfProductApproval extends Inherit(ProductApprovalController, Component) {
    render() {
        const { items, loading, pagination, selectedIds, busy } = this.state;
        const allSelected = items.length > 0 && selectedIds.length === items.length;

        return (
            <Layout current="product-approval" user={this.user}>
                {this.props.contextHolder}

                <PageHeader
                    icon={<PackageCheck />}
                    title="Aprobación de productos"
                    description="Productos escaneados por auditores, pendientes de aprobación · más recientes primero"
                    actions={
                        <Button icon={<RotateCw />} loading={loading} onClick={() => this.loadQueue(pagination.page || 1)}>
                            Actualizar
                        </Button>
                    }
                />

                <div className="shelf-card px-4 py-3 mb-4">
                    <div className="flex flex-wrap items-center justify-between gap-3">
                        <div className="flex flex-wrap items-center gap-3">
                            <Checkbox
                                checked={allSelected}
                                indeterminate={selectedIds.length > 0 && !allSelected}
                                onChange={(e) => this.toggleSelectAll(e.target.checked)}>
                                Seleccionar todo
                            </Checkbox>
                            <div className="hidden h-6 w-px bg-surface-200 sm:block" />
                            <Button
                                type="primary"
                                icon={<CircleCheck />}
                                loading={busy}
                                disabled={!selectedIds.length}
                                onClick={() => this.approveSelected()}>
                                Aprobar seleccionados ({selectedIds.length})
                            </Button>
                            <Button danger icon={<CircleX />} loading={busy} disabled={!selectedIds.length} onClick={() => this.rejectSelected()}>
                                Rechazar seleccionados ({selectedIds.length})
                            </Button>
                        </div>
                        <span className="text-sm text-surface-500">
                            <span className="font-semibold text-surface-900 tabular-nums">{pagination.total ?? 0}</span> producto(s) por aprobar
                        </span>
                    </div>
                </div>

                {loading && !items.length ? (
                    <div className="grid gap-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="shelf-card p-4">
                                <Skeleton avatar={{ shape: 'square', size: 64 }} active paragraph={{ rows: 3 }} />
                            </div>
                        ))}
                    </div>
                ) : items.length ? (
                    <>
                        <div className="grid gap-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                            {items.map((item, idx) => (
                                <AuditReviewCard
                                    key={item.product?._id || idx}
                                    item={item}
                                    selected={selectedIds.includes(item.product?._id)}
                                    onSelect={this.toggleSelect}
                                    onApprove={this.approve}
                                    onReject={this.reject}
                                    onEdit={this.openInConsole}
                                    onRecordClick={this.openRecords}
                                />
                            ))}
                        </div>
                        <div className="flex justify-end mt-6">
                            <Pagination
                                current={pagination.page}
                                pageSize={pagination.limit}
                                total={pagination.total}
                                showSizeChanger={false}
                                onChange={(page) => this.loadQueue(page)}
                            />
                        </div>
                    </>
                ) : (
                    <div className="shelf-card">
                        <EmptyState
                            icon={<PackageCheck />}
                            title="Todo al día"
                            description="No hay productos pendientes de aprobación"
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfProductApproval);
